import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page49',
  templateUrl: './page49.component.html',
  styleUrls: ['./page49.component.css']
})
export class Page49Component implements OnInit {
  @Input() data: any;
  constructor() { }

  ngOnInit(): void {
  }

}
